var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('remote-js',{attrs:{"src":this.jsUrl},on:{"load-js-finish":this.jsLoadCallBack}})}
var staticRenderFns = []

export { render, staticRenderFns }